import React, { useEffect, useState } from "react";
import { qformat, DATE_FORMATS } from "views_shared/app/javascript/utils/dateFormatters";
import { authenticatedHeadersHash } from "views_shared/app/javascript/scripts/authentication";
import AgencyRow from "./AgencyRow";

function AgencyAnalytics() {
  const [period, setPeriod] = useState("last_quarter"); // Default period
  const [agencies, setAgencies] = useState([]);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [order, setOrder] = useState("desc"); // Order for total points
  const [loading, setLoading] = useState(false); // Loading state

  // Fetch analytics data based on period and order
  useEffect(() => {
    setLoading(true);
    setAgencies([]);
    const queryString = `/interact/api/agency_analytics?period=${period}&order=${order}`;

    fetch(queryString, {
      cache: "no-store",
      method: "GET",
      headers: new Headers(authenticatedHeadersHash()),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        const { data } = responseJson;
        setStartTime(qformat(data.start_time, DATE_FORMATS.date, null));
        setEndTime(qformat(data.end_time, DATE_FORMATS.date, null));
        setAgencies(data.agencies);
        setLoading(false);
      })
      .catch((error) => {
        // eslint-disable-next-line no-alert
        alert(`Error: ${error}`);
        setLoading(false);
      });
  }, [period, order]);

  // Toggle order between ascending and descending
  function toggleOrder() {
    setOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
  }

  return (
    <div>
      <div className="period-selector mb-3">
        <div className="btn-group btn-group-toggle" data-toggle="buttons">
          {[
            "today",
            "yesterday",
            "this_week",
            "last_week",
            "this_month",
            "last_month",
            "this_quarter",
            "last_quarter",
            "this_year",
            "last_year",
            "all_time",
          ].map((p) => (
            <label key={p} className={`btn btn-secondary ${period === p ? "active" : ""}`}>
              <input
                type="radio"
                value={p}
                checked={period === p}
                onChange={(e) => setPeriod(e.target.value)}
                autoComplete="off"
              />{" "}
              {p.replace(/_/g, " ")}
            </label>
          ))}
        </div>
      </div>
      <div>
        <p>
          Timespan: {startTime}&nbsp;&ndash;&nbsp;{endTime}
        </p>
      </div>
      {loading ? (
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Agency</th>
              <th>Pitches</th>
              <th>Conversations</th>
              <th>Bad Behavior Points</th>
              <th onClick={toggleOrder} style={{ cursor: "pointer" }}>
                Total Points {order === "asc" ? "▲" : "▼"}
              </th>
            </tr>
          </thead>
          <tbody>
            {agencies.map((agency, index) => (
              <AgencyRow key={agency.company_slug} agency={agency} rank={index + 1} />
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AgencyAnalytics;
